export const MEDIA = {
  laptop_xl: '2560px',
  laptop_l: '1440px',
  laptop: '1024px',
  tablet: '768px',
  mobile_l: '425px',
  mobile_m: '375px',
  mobile_s: '320px'
};
